import { render } from "./Paragraph.vue?vue&type=template&id=3991dbec&scoped=true"
import script from "./Paragraph.vue?vue&type=script&lang=js"
export * from "./Paragraph.vue?vue&type=script&lang=js"

import "./Paragraph.vue?vue&type=style&index=0&id=3991dbec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3991dbec"]])

export default __exports__